/**
 * Model Viewer Shim
 * This file provides a shim for @google/model-viewer to prevent import errors
 */

// Set up a flag to track if model-viewer is loaded
let isModelViewerAvailable = false;

// This function attempts to load model-viewer
async function loadModelViewer() {
  try {
    if (typeof window !== 'undefined') {
      // Try to dynamically import model-viewer
      await import('@google/model-viewer');
      
      // If we get here, model-viewer loaded successfully
      isModelViewerAvailable = true;
      console.info('Google model-viewer loaded successfully');
      return true;
    } else {
      // Not in a browser environment
      console.warn('Not in browser environment, model-viewer unavailable');
      return false;
    }
  } catch (error) {
    console.error('Failed to load @google/model-viewer:', error);
    return false;
  }
}

// This function checks if model-viewer is available
function isModelViewerLoaded() {
  return isModelViewerAvailable;
}

// This function checks if the browser is likely to support model-viewer
function checkBrowserSupport() {
  if (typeof window === 'undefined') return false;
  
  // Basic check for WebGL support
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  
  if (!gl) {
    console.warn('WebGL not supported, model-viewer may not work');
    return false;
  }
  
  // Basic mobile detection
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (isMobile) {
    console.warn('Mobile device detected, model-viewer may have limited functionality');
    // Return true anyway, as model-viewer can still work on some mobile devices
    return true;
  }
  
  return true;
}

export { loadModelViewer, isModelViewerLoaded, checkBrowserSupport };

// Default export is a proxy to allow for "import ModelViewer from..." syntax
export default {
  loadModelViewer,
  isModelViewerLoaded,
  checkBrowserSupport
};